import { Box, Card, CircularProgress, IconButton, Stack, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CachedIcon from '@mui/icons-material/Cached';
import TrackChangesSharpIcon from '@mui/icons-material/TrackChangesSharp';
import { partnerTotalRevenueAction } from '../../redux/toolkit/dashbaord/partnerTotalRevenue';

const PartnerTotalRevenue = () => {
  // state
  const dispatch = useDispatch()
  const totalRevenue = useSelector(state => state.partnerTotalRevenue)
  const { data, loading } = totalRevenue

  // fn
  const handleRefeash = () => {
      dispatch(partnerTotalRevenueAction())
  }

  // use effect
  useEffect(() => {
      dispatch(partnerTotalRevenueAction())
  }, [dispatch])
  return (
      <Card sx={{ p: 2, color: '#0C6A96' }} >
          <Stack direction='row' justifyContent='space-between' >
              <TrackChangesSharpIcon color='#0C6A96' />
              <Typography sx={{ color: '#5E6C8A', fontFamily: 'Montserrat,sans-serif', fontStyle: 'normal' }} variant='subtitle2'> Partner Total Revenue</Typography>
              <IconButton sx={{ color: '#5E6C8A' }} onClick={handleRefeash}><CachedIcon /></IconButton>
          </Stack>

          {
              loading
                  ? <CircularProgress />
                  : <Box>
                      <Typography variant='h3' color='primary' sx={{ fontWeight: 600, color: '#071D45' }}>{data[0]?.publisher_payout ? Number(data[0]?.publisher_payout ).toFixed(4) : "---"}</Typography>
                  </Box>
          }
      </Card>
  )
}

export default PartnerTotalRevenue
